module.exports = __webpack_public_path__ + "media/images/alique-partner-ddd483f386b90a9849058c14d5350807.png";